"use client";

import { TonightPrefetchProvider } from "@/hooks/use-tonight-prefetch";

/** Mounts the shared tonight prefetch provider (auto-download on Wi‑Fi). */
export function TonightPrefetchRunner({ children }: { children?: React.ReactNode }) {
    return <TonightPrefetchProvider>{children ?? null}</TonightPrefetchProvider>;
}
